import React, { Component } from "react";
import Modal from "../../../UIComponents/CustomModal/Modal";
import "./TempoTractionModal.css";
import { drawCharts } from "./chartUtils";
import moment from "moment-timezone";

class TempoTractionModal extends Component {
    componentDidUpdate(oldProps) {
        if (oldProps.open === false && this.props.open === true) drawCharts(this.impactChartCont, this.tractionChartCont, this.props.data);
    }

    render() {
        let tractionScore = null;
        let thresholdValue = JSON.parse(localStorage.getItem("company")).virality_impact_threshold;
        if (this.props.data && this.props.data.traction) {
            tractionScore = this.props.data.traction.reduce((x, y) => (x > y ? x : y));
            tractionScore = parseFloat(tractionScore).toFixed(3);
        }

        return (
            <Modal className="tempo-traction-modal" show={this.props.open} onClose={() => this.props.hideModal()}>
                <Modal.Header>IMPACT AND TRACTION GRAPH</Modal.Header>
                <Modal.Content>
                    {this.props.data && (
                        <section className="period">
                            PERIOD :{" "}
                            {`${moment(this.props.data.dates[0]).format("LL, HH")} Hrs TO ${moment(
                                this.props.data.dates[this.props.data.dates.length - 1],
                            ).format("LL, HH:mm")} Hrs`}
                        </section>
                    )}
                    <section className="charts">
                        <div className="impact-chart">
                            <div>
                                <span className="title"> IMPACT OVER TIME </span>
                                {this.props.data && (
                                    <span className="score"> HIGHEST IMPACT SCORE: {this.props.data.impact.reduce((x, y) => (x > y ? x : y))} </span>
                                )}
                            </div>
                            <div
                                className="impact-chart-cont"
                                ref={(el) => {
                                    this.impactChartCont = el;
                                }}></div>
                        </div>
                        <div className="traction-chart">
                            <div>
                                <span className="title">TRACTION OVER TIME</span>
                                {this.props.data && <span className="score"> HIGHEST TRACTION SCORE: {tractionScore} </span>}
                            </div>
                            <div
                                className="traction-chart-cont"
                                ref={(el) => {
                                    this.tractionChartCont = el;
                                }}></div>
                        </div>
                        <div className="footer-text">
                            <p> *Impact Over time - Displays the volume of engagement in realtime </p>
                            <p> *Traction Over time - displays the speed at which users are engaging with the post </p>
                        </div>
                        <div className="threshold-text">
                            <p>*Virality Threshold is set to {thresholdValue} Impact Score</p>
                        </div>
                    </section>
                </Modal.Content>
            </Modal>
        );
    }
}

export default TempoTractionModal;
